// extracted by mini-css-extract-plugin
export var modal = "_sx-0";
export var table = "_sx-1";